import { x } from '@xstyled/styled-components';
import React, { Children } from 'react';
import { t } from 'ttag';

import EnvelopeIcon from '~/assets/icons/envelope.svg';
import { Card } from '~/ui/card/Card';
import { Flex } from '~/ui/flex/Flex';
import { Item, registry, RenderProps } from '../Item';
import { ENVELOPE } from '../itemIds';
import EnvelopeImage from './envelope.png';
import { Logo } from '~/ui/logo/Logo';
import { TrainingState, useTrainingStore } from '~/training/state';
import { select } from '~/lib/select';
import * as S from './styles';
import { isUserNameLine, UserNameLine } from '../email/UserNameLine';

interface Props {
  from: string;
  subject: string;
  logo?: string;
}

const selector = (s: TrainingState) => select(s, 'logoUrl', 'featureShowLlama');

export class Envelope extends Item<typeof ENVELOPE, Props> {
  protected render({ id, children, logo }: RenderProps<Props>) {
    const { logoUrl, featureShowLlama } = useTrainingStore(selector);

    return (
      <Flex variant="center" w="100%" minWidth={0}>
        <Card
          backgroundColor="white"
          className="envelopeStyleForDarkTheme"
          color="greyDark"
          display="flex"
          flexDirection="column"
          marginBottom={{ _: '0px', lg: '100px' }}
          minH="300px"
          paddingBottom="20px"
          position="relative"
          // CAT-122x / WCAG 1.4.10: shrink inside padded columns at 320 CSS px
          w="100%"
          maxW={{ _: '350px', md: '399px' }}
          boxSizing="border-box"
        >
          <S.Header>
            <EnvelopeIcon aria-hidden="true" focusable="false" />

            <x.b>{t`You've got mail!`}</x.b>
          </S.Header>

          <x.div zIndex={3} p="20px" paddingBottom="70px">
            <S.Body>
              {Children.toArray(children).map(child =>
                isUserNameLine(child, id) ? (
                  <UserNameLine key="user-name">{child}</UserNameLine>
                ) : (
                  child
                )
              )}
            </S.Body>
          </x.div>

          {logo ? (
            <Logo
              src={
                typeof logo === 'string' && logo.trim() !== '' ? logo : logoUrl
              }
              height={96}
              alt=""
              aria-hidden="true"
              style={{
                position: 'absolute',
                zIndex: 1,
                bottom: '20px',
                right: '60px',
                width: '96px',
                height: '96px',
                objectFit: 'contain'
              }}
            />
          ) : featureShowLlama ? (
            <S.Stamp aria-hidden="true" focusable="false" />
          ) : null}

          <S.EnvelopeBackground src={EnvelopeImage} alt="" />
        </Card>
      </Flex>
    );
  }
}

registry[ENVELOPE] = Envelope;
